/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class VerticalNavGroupService {
private _expandChange: Subject<boolean> = new Subject<boolean>();
/**
 * @return {?}
 */
get expandChange(): Observable<boolean> {
        return this._expandChange.asObservable();
    }
/**
 * @return {?}
 */
expand(): void {
        this._expandChange.next(true);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VerticalNavGroupService_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavGroupService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavGroupService.ctorParameters;
/** @type {?} */
VerticalNavGroupService.prototype._expandChange;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
